import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Review from '@/components/Review'
import Browse from '@/components/Browse'
import Login from '@/components/Login'
import EditReview from '@/components/EditReview'
import Launcher from '@/components/Launcher'
import Game from '@/components/Game'
import Games from '@/components/Games'
import { store } from '../framework/store';

Vue.use(Router)

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/browse', name: 'Browse', component: Browse },
    { path: '/browse/reviewer', name: 'ReviewerBrowse', component: Browse, props: { reviewMode: true } },
    { path: '/review/:_id', name: 'Review', component: Review, props: true }, // _id so that this.id can be set at runtime in case _id is an int the real id can be looked up
    { path: '/review/:id/edit', name: 'EditReview', component: EditReview, props: true },
    { path: '/login', name: 'Login', component: Login },
    { path: '/launcher', name: 'Launcher', component: Launcher },
    { path: '/game/:id', name: 'Game', component: Game, props: true },
    { path: '/games', name: 'Games', component: Games, props: true }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js